/** Scale complete readings without changing their precision or dropping their units. */
export function statisticFit(available: number, natural: number, minimum = .3): number {
  if (!Number.isFinite(available) || !Number.isFinite(natural) || available <= 0 || natural <= 0) return 1;
  return Math.min(1, Math.max(minimum, (available - 1) / natural));
}

export function fitStatisticReading(container: HTMLElement, minimum: number): void {
  const reading = container.querySelector<HTMLElement>('.statistic-reading');
  if (!reading) return;
  reading.style.removeProperty('--statistic-fit');
  const available = container.getBoundingClientRect().width;
  const natural = reading.getBoundingClientRect().width;
  const scale = statisticFit(available, natural, minimum);
  if (scale < 1) reading.style.setProperty('--statistic-fit', String(scale));
}

export interface TextBounds { left: number; top: number; right: number; bottom: number }
export function statisticTextOutside(container: TextBounds, text: TextBounds, tolerance = 2): boolean {
  return text.left < container.left - tolerance || text.right > container.right + tolerance
    || text.top < container.top - tolerance || text.bottom > container.bottom + tolerance;
}

/** Text ranges ignore empty scroll extents caused by browser line-box rounding. */
export function statisticTextOverflows(element: HTMLElement): boolean {
  const range = element.ownerDocument.createRange();
  range.selectNodeContents(element);
  return [...range.getClientRects()].some(rect => rect.width > 0 && rect.height > 0
    && statisticTextOutside(element.getBoundingClientRect(), rect));
}
